import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';

export default class PostingNoticeWidget extends Component {
  view() {
    const notice = this.getNoticeContent();

    if (!notice) {
      return null;
    }

    return (
      <div className="PostingNoticeWidget">
        <div className="PostingNoticeWidget-content" innerHTML={notice}></div>
      </div>
    );
  }

  getNoticeContent() {
    // Check if we're on a tag page - Flarum uses 'tags' as the route parameter
    const tagSlug = m.route.param('tags');

    // On tag page - check for tag-specific notice first
    const tag = app.store.getBy('tags', 'slug', tagSlug);
    if (tag) {
      const tagNotice = tag.attribute('postingNotice');
      if (tagNotice && tagNotice.trim()) {
        return tagNotice;
      }
    }

    // Fallback to default notice on tag pages without a specific notice
    return app.forum.attribute('postingNoticeDefault') || '';
  }
}
